import { createContext, useState } from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "../error_pages/NotFound";

// screens
import Dashboard from "../dashboard/Dashboard";
import Schools from "../schools/Schools";
import ErrorBoundary from "../../components/error/AppErrorBoundary";
import TwoFactorAuthentication from "../authentication/TwoFactorAuthentication";
import ProtectedRoute from "./ProtectedRoute";
import Signin from "../authentication/Sigin";
import AddUpdateSchool from "../schools/AddUpdateSchool";
import AddSchoolPayment from "../payments/AddSchoolPayment";
import SubscriptionDashboard from "../subscriptions/SubscriptionDashboard";
import AddUpdateSubscriptionPackage from "../subscriptions/AddUpdateSubscriptionPackage";
import SubscriptionPackages from "../subscriptions/SubscriptionPackages";
import PaymentDashboard from "../payments/PaymentDashboard";

export const AuthContext = createContext();

const Root = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="container">
      <Routes>
        <Route element={<ProtectedRoute />} errorElement={<ErrorBoundary />}>
          <Route
            element={
              <Dashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            path="/dashboard"
          />
          <Route
            path="/schools"
            element={
              <Schools
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/school/add"
            element={
              <AddUpdateSchool
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/school/:schoolId/update"
            element={
              <AddUpdateSchool
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/payment"
            element={
              <PaymentDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/payment-add"
            element={
              <AddSchoolPayment
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />

          {/* subscriptions */}
          <Route
            path="/subscription/home"
            element={
              <SubscriptionDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subscription-package-add"
            element={
              <AddUpdateSubscriptionPackage
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subscription-package/:subscriptionPackageId/update"
            element={
              <AddUpdateSubscriptionPackage
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subscription/packages"
            element={
              <SubscriptionPackages
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
        </Route>

        <Route
          path="/authentication/two-factor"
          element={<TwoFactorAuthentication />}
          errorElement={<ErrorBoundary />}
        />

        <Route path="/" element={<Signin />} errorElement={<ErrorBoundary />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/not-found" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Root;
